import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { getResumeDetails } from "../../slice/workerResumeSlice";

const WorkerResumeDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const { resumeDetails, loading, error } = useSelector(
    (state) => state.workerResume
  );

  useEffect(() => {
    dispatch(getResumeDetails(id));
  }, [id, token, dispatch]);

  // if (loading) return <p>Loading resume details...</p>;
  // if (error) return <p className="text-danger">{error}</p>;
  if (!resumeDetails) return null;

  const skillsArray = resumeDetails?.skills?.split(",") || [];

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-3">
        <h4 className="font-weight-bold text-primary font-size-40 line-hight-2 montserrat mb-0">
            Resume Details
          </h4>
          <button
            className="btn btn-light-header"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
          </div>

          {/* LOADING */}
          {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>}

          {/* ERROR */}
          {error && <p className="text-danger">{error}</p>}
          
        <div className="card shadow-sm p-4">

          {/* Header */}
          <div className="border-bottom pb-3 mb-4">
            <h2 className="text-primary mb-1">{resumeDetails.title}</h2>
            <h5 className="text-muted">{resumeDetails.headline}</h5>
          </div>

          {/* Summary */}
          <div className="mb-4">
            <h5 className="text-muted">Professional Summary</h5>
            <p>{resumeDetails.summary}</p>
          </div>

          {/* Skills */}
          <div className="mb-4">
            <h5 className="text-muted">Skills</h5>
            <div>
              {skillsArray?.map((skill, index) => (
                <span
                  key={index}
                  className="badge bg-primary me-2 mb-2"
                >
                  {skill.trim()}
                </span>
              ))}
            </div>
          </div>

          {/* Experience */}
          <div className="mb-4">
            <h5 className="text-muted">Work Experience</h5>

            {resumeDetails?.experience?.length > 0 ? (
              resumeDetails.experience.map((exp) => (
                <div key={exp.id} className="border rounded p-3 mb-3">
                  <div className="d-flex justify-content-between">
                    <h6 className="mb-0">{exp.job_title}</h6>
                    <small className="text-muted">
                      {exp.start_date} – {exp.end_date || "Present"}
                    </small>
                  </div>
                  <p className="mb-1 fw-semibold">{exp.company}</p>
                  <p className="mb-0">{exp.description}</p>
                </div>
              ))
            ) : (
              <p className="text-muted">No experience added.</p>
            )}
          </div>

          {/* Education */}
          <div>
            <h5 className="text-muted">Education & Certifications</h5>

            {resumeDetails?.education?.length > 0 ? (
              resumeDetails.education.map((edu) => (
                <div key={edu.id} className="border rounded p-3 mb-3">
                  <div className="d-flex justify-content-between">
                    <h6 className="mb-0">{edu.school_or_cert}</h6>
                    <small className="text-muted">
                      {edu.start_year} – {edu.end_year}
                    </small>
                  </div>
                  <p className="mb-1 fw-semibold">
                    {edu.degree} ({edu.field})
                  </p>
                  <p className="mb-0">{edu.description}</p>
                </div>
              ))
            ) : (
              <p className="text-muted">No education details added.</p>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default WorkerResumeDetails;
